export default __webpack_public_path__ + "static/notfoundDesktop-2a60b7ef536f59dda532ef80cd947183.png";